import styled from "styled-components";

const Style = styled.div`
  background: #EDF6FE;
  height: 431px;
  box-shadow: 0px 4px 8px rgba(16, 24, 40, 0.1), 0px 2px 4px rgba(16, 24, 40, 0.06);
  display: flex;
  flex-direction: column;
  position: relative;

  .react-flow__node-default .react-flow__handle {
    background: transparent;
    border-color: transparent;
  }

  .react-flow__node-default {
    border: 0px;
    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  }

  .actions {
    position: absolute;
    bottom: 15px;
    left: 15px;
    display: flex;
    z-index: 100;
    gap: 12px;
  
    .action {
      padding: 6px 12px;
      display: flex;
      gap: 8px;
      background: white;
      border: 1px solid #D0D5DD;
      border-radius: 2px;


      label {
        color: #344054;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 0px;
      }

      .ant-checkbox {
        transform: scale(0.8);
      }
    }
  }
`

export default Style;
